module.exports = __webpack_public_path__ + "static/media/green-cluster.588112e6.svg";